<mat-toolbar>
  <!-- Logo o título -->
  <span class="toolbar-title">Split Panas</span>

  <!-- Espaciador para alinear a la derecha -->
  <span class="spacer"></span>


  <!-- Ícono de usuario con menú desplegable -->
  <!-- Nombre del usuario y botón de perfil -->
  <div class="user-info">
    <span class="user-name">{{ loggedUser?.preferred_username }}</span>
    <button mat-icon-button [matMenuTriggerFor]="userMenu">
      <mat-icon>account_circle</mat-icon>
    </button>
    <mat-menu #userMenu="matMenu">
      <button mat-menu-item (click)="logout()">Cerrar sesión</button>
    </mat-menu>
  </div>
</mat-toolbar>
